export const toFirstLetterLowercased = (text: string): string =>
	text.charAt(0).toLowerCase() + text.slice(1);
